// Contracts — здоровье бота приёмки (weern-contrib-bot, GET /api/ctb/health).
//
// Ручка публичная и НЕ часть бот-лейна: она отвечает всем, но не говорит
// ничего о людях. Только счётчики и возрасты в секундах — ни токенов, ни
// имён, ни user_id, ни текстов сообщений. Схема здесь и есть тот забор:
// поле, которого в ней нет, наружу не уедет.
//
// Читателя два, и оба разбирают ответ ЭТОЙ схемой: независимый сторож в
// weern-tgbot (крон каждые 5 минут) и человек с curl.
//
// Почему счётчики nullable, а не 0: null = «не смог посмотреть» (D1
// недоступна), 0 = «посмотрел, пусто». Схлопнуть их в ноль значит превратить
// упавшую базу в «всё тихо, ноль в очереди» — ровно тот тихий отказ, ради
// которого ручка и заведена.
import { z } from 'zod';

export const CtbHealthResSchema = z.object({
  /** true = воркер жив И смог прочитать своё состояние в D1. */
  ok: z.boolean(),
  service: z.literal('weern-contrib-bot'),
  /** Время ответа воркера: по нему читатель считает возрасты сам, если надо. */
  now: z.string(),
  /** Пусто при ok:true; иначе короткая причина (без секретов и PII). */
  reason: z.string(),
  /** Сколько секунд назад успешно закончился тик крона; null = ни разу. */
  cron_age_s: z.number().nullable(),
  /** Сколько секунд назад вебхук принял апдейт; null = ни разу. */
  update_age_s: z.number().nullable(),
  campaigns_active: z.number().nullable(),
  users: z.number().nullable(),
  outbox_queued: z.number().nullable(),
  /** Возраст самой старой строки в статусе queued; null = очередь пуста. */
  outbox_oldest_queued_s: z.number().nullable(),
  events_awaiting_verdict: z.number().nullable(),
  /** Возраст самого старого события без вердикта; null = таких нет. */
  events_oldest_awaiting_s: z.number().nullable(),

  // Долговечная входящая очередь (tg_contrib_inbox, мигр. work/0078). Апдейт
  // ложится в неё ДО ответа 200 и помечается done только после обработки,
  // поэтому потерянное сообщение здесь ВИДНО — раньше его не показывал никто.
  // Наружу уходят только счётчики: в строках лежит текст человека.
  /** Принято и ещё не обработано. */
  inbox_pending: z.number().nullable(),
  /** Обработка сорвалась, попытки не исчерпаны — крон повторит. */
  inbox_failed: z.number().nullable(),
  /** Попытки исчерпаны: сообщение человека принято и НЕ обработано. Любое
   *  ненулевое значение — повод для тревоги, само оно не рассосётся. */
  inbox_dead: z.number().nullable(),
  /** Возраст самой старой строки в статусе pending; null = таких нет. */
  inbox_oldest_pending_s: z.number().nullable(),
});
export type CtbHealthRes = z.infer<typeof CtbHealthResSchema>;
